(() => {
  const isBlocked = (control) => control instanceof Element && control.matches('.inventa-button[aria-busy="true"], .inventa-button[aria-disabled="true"]');
  document.addEventListener('click', (event) => {
    const control = event.target instanceof Element ? event.target.closest('.inventa-button') : null;
    if (!isBlocked(control)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  document.addEventListener('submit', (event) => {
    if (!isBlocked(event.submitter)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
})();

// Only navigation is enhanced: the existing scroll area keeps its layout and inputs.
if (!customElements.get('inventa-carousel-controls')) {
  customElements.define('inventa-carousel-controls', class extends HTMLElement {
    connectedCallback() {
      this.rail = document.getElementById(this.getAttribute('target'));
      this.previous = this.querySelector('[data-carousel-previous]');
      this.next = this.querySelector('[data-carousel-next]');
      if (!this.rail || !this.previous || !this.next) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.queueUpdate = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.rail.addEventListener('scroll', this.queueUpdate, { ...options, passive: true });
      this.rail.addEventListener('keydown', (event) => {
        if (event.target !== this.rail || !['Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.scrollTo(event.key === 'Home' ? 0 : this.rail.scrollWidth - this.rail.clientWidth);
      }, options);
      this.resizer = new ResizeObserver(this.queueUpdate);
      this.resizer.observe(this.rail);
      this.rail.dataset.inventaCarouselReady = 'true';
      this.update();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.resizer?.disconnect();
      cancelAnimationFrame(this.frame);
      if (this.rail) delete this.rail.dataset.inventaCarouselReady;
    }

    update() {
      const maximum = this.rail.scrollWidth - this.rail.clientWidth;
      const position = Math.abs(this.rail.scrollLeft);
      this.hidden = maximum <= 1;
      this.previous.setAttribute('aria-disabled', String(position <= 1));
      this.next.setAttribute('aria-disabled', String(position >= maximum - 1));
    }

    move(direction) {
      if ((direction < 0 ? this.previous : this.next).getAttribute('aria-disabled') === 'true') return;
      const style = getComputedStyle(this.rail);
      const first = this.rail.firstElementChild;
      const gap = parseFloat(style.columnGap) || 0;
      const step = first ? first.getBoundingClientRect().width + gap : this.rail.clientWidth;
      const items = Math.max(1, Math.floor((this.rail.clientWidth + gap) / step));
      this.scrollTo(Math.abs(this.rail.scrollLeft) + direction * step * items);
    }

    scrollTo(position) {
      const maximum = this.rail.scrollWidth - this.rail.clientWidth;
      const direction = getComputedStyle(this.rail).direction === 'rtl' ? -1 : 1;
      const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.rail.scrollTo({ left: direction * Math.max(0, Math.min(maximum, position)), behavior: reduceMotion ? 'instant' : 'smooth' });
    }
  });
}
